import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-trip-action-dropdown',
  templateUrl: './trip-action-dropdown.component.html',
  styleUrls: ['./trip-action-dropdown.component.css']
})
export class TripActionDropdownComponent {
  @Input() trip: any;
  @Input() source: any;
  @Input() isReserved!: (trip: any) => boolean;
  @Output() adjustTrip = new EventEmitter<any>();
  @Output() detail = new EventEmitter<any>();
  @Output() notes = new EventEmitter<any>();
  @Output() tripTrails = new EventEmitter<any>();
  @Output() getMarketplaceTrip = new EventEmitter<any>();
 @Output() reserveTrip = new EventEmitter<[any, boolean]>();
  @Output() cancel = new EventEmitter<any>();
  @Output() reroute = new EventEmitter<any>();
  @Output() signature = new EventEmitter<any>();
  @Output() raiseTicket = new EventEmitter<any>();

}


